// Deeplinks in die VARIO-Oberfläche (Artikel, Verkaufskanal, Verkaufsauftrag).

/**
 * Vario-Article-Detail-Deeplink. Format (vom User vorgegeben):
 *   `https://<vario-host>/products/articles/{articleId}/dashboard`
 *
 * Der Vario-Host (= Tenant-spezifische Subdomain wie `goecommerce.vario.cloud`) wird zur
 * Laufzeit aus dem Browser-Kontext bestimmt:
 *   1) `window.location.ancestorOrigins[0]` — wenn wir in der Vario-iframe laufen
 *   2) `document.referrer` — Fallback wenn ancestorOrigins nicht unterstützt
 *   3) wenn keins greift → null (Icon wird dann disabled gerendert)
 */
export function varioArticleUrl(articleId: string | null): string | null {
  if (!articleId) return null;
  const base = detectVarioBaseUrl();
  if (!base) return null;
  return `${base}/products/articles/${encodeURIComponent(articleId)}/dashboard`;
}

/**
 * Vario-VERKAUFSKANAL-Deeplink (Kanal-Listing eines Artikels). Format wie im Varianten-Grid:
 *   `https://<vario-host>/products/articles/{articleId}/listings/{listingId}`
 * Braucht Artikel-ID UND Vario-Listing-ID (beide aus otto.units_with_mapping:
 * channel_vario_article_id / channel_vario_listing_id). Host-Detection wie varioArticleUrl();
 * fehlt eine ID oder der Host → null (Aufrufer fällt auf varioArticleUrl zurück).
 */
export function varioListingUrl(articleId: string | null, listingId: string | null): string | null {
  if (!articleId || !listingId) return null;
  const base = detectVarioBaseUrl();
  if (!base) return null;
  return `${base}/products/articles/${encodeURIComponent(articleId)}/listings/${encodeURIComponent(listingId)}`;
}

/**
 * Vario-Verkaufsauftrag-Deeplink. Format (vom User 2026-05-18 verifiziert):
 *   `https://<vario-host>/documents-sales/{varioOrderId}`
 * `/sales/orders/{id}/dashboard` lieferte 404 — Vario routet Aufträge unter
 * `documents-sales` (Belegart-Group). Host-Detection siehe detectVarioBaseUrl();
 * null = nicht im Vario-iframe → Link wird nicht klickbar gerendert.
 */
export function varioSalesOrderUrl(varioOrderId: string | null): string | null {
  if (!varioOrderId) return null;
  const base = detectVarioBaseUrl();
  if (!base) return null;
  return `${base}/documents-sales/${encodeURIComponent(varioOrderId)}`;
}

function detectVarioBaseUrl(): string | null {
  // 1) ancestorOrigins (Chrome/Safari, nicht Firefox)
  const ancestors = (window.location as Location & { ancestorOrigins?: DOMStringList }).ancestorOrigins;
  if (ancestors && ancestors.length > 0) {
    const top = ancestors[ancestors.length - 1];
    if (top && /\.vario\.cloud$/i.test(new URL(top).hostname)) return top.replace(/\/+$/, '');
  }
  // 2) document.referrer (alle Browser, fällt aber bei nachträglicher Navigation aus)
  if (document.referrer) {
    try {
      const refUrl = new URL(document.referrer);
      if (/\.vario\.cloud$/i.test(refUrl.hostname)) return `${refUrl.protocol}//${refUrl.host}`;
    } catch {
      /* ignore */
    }
  }
  return null;
}
